import { createElement } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    entityKey: PropTypes.string,
    getEditorState: PropTypes.func.isRequired,
    LinkReplacer: PropTypes.func,
};

const DefaultLink = ({ children, className, entityKey, getEditorState, target, LinkReplacer }) => {
    const entity = getEditorState().getCurrentContent().getEntity(entityKey);
    const entityData = entity ? entity.get('data') : undefined;
    const href = (entityData && entityData.url) || undefined;
    return LinkReplacer ? (
        // eslint-disable-next-line react/no-children-prop
        createElement(LinkReplacer, {
            className,
            title: href,
            href,
            target,
            rel: 'noopener noreferrer',
            children,
        })
    ) : (
        <a className={className} title={href} href={href} target={target} rel="noopener noreferrer">
            {children}
        </a>
    );
};

DefaultLink.propTypes = propTypes;
export default DefaultLink;
